module.exports = __webpack_public_path__ + "static/media/cs-web(1).2d3a295a.jpg";